module.exports = __webpack_public_path__ + "img/app_logo_sm.fa100d66.png";